export const Services = {
   "MAIL": {
      "path": "https://roldanapimail.azurewebsites.net",
      "descrp": "API Admin"
   }
}